import React, { useState } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import {
    TextField,
    Select,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    Grid,
    Checkbox,
    FormControlLabel,
    InputAdornment,
    FormGroup,
    Box,
    Typography,
    Card,
    IconButton,
    CardHeader,
    CardContent,
    Divider,
    ThemeProvider,
    FormHelperText,
    Snackbar,
    Alert,
    CircularProgress,
    Breadcrumbs,
    Tooltip,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { styled } from "@mui/material/styles";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { putUserPassword } from "../../components/API/userAPI";
import BaseFormWrapper from "../../components/shared/BaseFormWrapper";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1e5d45", // Custom primary color
        },
    },
});


const StyledHr = styled("hr")(({ theme }) => ({
    border: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(4, 0),
    opacity: 0.8,
}));

function ChangePassword() {
    const { id } = useParams();
    const [showPasswords, setShowPasswords] = useState({
        password: false,
        confirmPassword: false,
    });
    const [newPassword, setNewPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    const handleClickShowPassword = (field) => {
        setShowPasswords((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmitClick = async () => {
        setIsLoading(true);

        // Call the API to update the password
        const result = await putUserPassword(id, newPassword);

        if (result) {
            console.log("Password updated successfully:", result);
            alert("Password updated successfully!");
        } else {
            console.error("Failed to update password.");
            alert("Failed to update password. Please try again.");
        }

        setIsLoading(false);
    };

    return (

        <BaseFormWrapper
            titleIcon={<AdminPanelSettingsIcon />}
            title="Admin Hub"
            subTitle="Manage Users"
            subTitleRoute="/manage-users"
            formTitle="Change Password"
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            isLoading={isLoading}
        >
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField
                        label="Password"
                        type={showPasswords.password ? "text" : "password"}
                        id="password"
                        name="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)} // One-liner
                        size="small"
                        required
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() =>
                                            handleClickShowPassword("password")
                                        }
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"

                                    >
                                        {showPasswords.password ? (
                                            <VisibilityOff />
                                        ) : (
                                            <Visibility />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}

                    />
                </Grid>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitClick} // Attach the click handler
                        disabled={isLoading} // Disable while loading
                    >
                        {isLoading ? "Submitting..." : "Submit"}
                    </Button>
                </Grid>
            </Grid>
        </BaseFormWrapper>

        // <ThemeProvider theme={theme}>
        //     <Box sx={{ padding: "40px 60px" }}>
        //         <Card
        //             variant="outlined"
        //             style={{
        //                 marginTop: "40px",
        //                 marginBottom: "40px",
        //                 borderRadius: 0,
        //             }}
        //         >
        //             <CardHeader
        //                 title={
        //                     <Box
        //                         display="flex"
        //                         alignItems="center"
        //                         justifyContent="space-between"
        //                     >
        //                         <Box display="flex" alignItems="center">
        //                             <AdminPanelSettingsIcon
        //                                 sx={{
        //                                     fontSize: "40px",
        //                                     marginRight: "8px",
        //                                 }}
        //                             />
        //                             <Typography variant="h6">Admin Hub</Typography>
        //                         </Box>
        //                         <Breadcrumbs
        //                             aria-label="breadcrumb"
        //                             separator={<NavigateNextIcon fontSize="small" />}
        //                             sx={{ color: "white" }}
        //                         >
        //                             <Typography sx={{ color: "#ffffff99" }}>
        //                                 Admin Hub
        //                             </Typography>
        //                             <Typography
        //                                 component={RouterLink}
        //                                 to="/manage-job-orders"
        //                                 sx={{ color: "#ffffff99", textDecoration: "none" }}
        //                             >
        //                                 Manage Users
        //                             </Typography>
        //                             <Typography sx={{ color: "#ffffff", textDecoration: "none" }}>
        //                                 Change Password
        //                             </Typography>
        //                         </Breadcrumbs>
        //                     </Box>
        //                 }
        //                 sx={{
        //                     backgroundColor: "#1e5d45",
        //                     color: "white",
        //                     padding: "16px",
        //                 }}
        //             />
        //             <CardContent sx={{ padding: "20px" }}>
        //                 <Card variant="outlined" sx={{ padding: "20px" }}>
        //                     <CardHeader
        //                         title={
        //                             <Typography variant="h5" sx={{ fontWeight: "bold" }}>
        //                                 Change Password
        //                             </Typography>
        //                         }
        //                         sx={{ marginBottom: 2 }}
        //                     />
        //                     <Grid container spacing={3}>
        //                         <Grid item xs={6}>
        //                             <TextField
        //                                 label="Password"
        //                                 type={showPasswords.password ? "text" : "password"}
        //                                 id="password"
        //                                 name="password"
        //                                 value={newPassword}
        //                                 onChange={(e) => setNewPassword(e.target.value)} // One-liner
        //                                 size="small"
        //                                 required
        //                                 fullWidth
        //                                 InputProps={{
        //                                     endAdornment: (
        //                                         <InputAdornment position="end">
        //                                             <IconButton
        //                                                 onClick={() =>
        //                                                     handleClickShowPassword("password")
        //                                                 }
        //                                                 onMouseDown={handleMouseDownPassword}
        //                                                 edge="end"

        //                                             >
        //                                                 {showPasswords.password ? (
        //                                                     <VisibilityOff />
        //                                                 ) : (
        //                                                     <Visibility />
        //                                                 )}
        //                                             </IconButton>
        //                                         </InputAdornment>
        //                                     ),
        //                                 }}

        //                             />
        //                         </Grid>
        //                         <Grid item xs={4}>
        //                             <Button
        //                                 variant="contained"
        //                                 color="primary"
        //                                 onClick={handleSubmitClick} // Attach the click handler
        //                                 disabled={isLoading} // Disable while loading
        //                             >
        //                                 {isLoading ? "Submitting..." : "Submit"}
        //                             </Button>
        //                         </Grid>
        //                     </Grid>
        //                 </Card>
        //             </CardContent>
        //         </Card>
        //     </Box>
        // </ThemeProvider>
    )

}

export default ChangePassword;